import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export function exportTsdTablesToExcelSingleSheet(sheetsData) {
  const wb = XLSX.utils.book_new();
  const allRows = [];

  const headerStyle = {
    font: { name: "Century", bold: true, color: { rgb: "FFFFFF" } },
    fill: { fgColor: { rgb: "4F81BD" } }, // Blue background
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" }
    },
    alignment: { horizontal: "center", vertical: "center", wrapText: true }
  };

  sheetsData.forEach(({ sheetName, headers, subHeaders, rows, weeklyTotalRow, monthlyTotalRow }, index) => {
    if (index > 0) allRows.push([]); // empty row as separator

    // First Header Row
    const firstHeader = ["NAME", "JOB POSITION"];
    const monthlyColSpans = subHeaders.map(month => month.ranges.length + 1);
    const reportSpan = monthlyColSpans.reduce((a, b) => a + b, 0);
    firstHeader.push("MONTHLY PRODUCTIVITY REPORT", ...Array(reportSpan).fill(""));
    // firstHeader.push("TOTAL WORKING DAYS", "AVERAGE GOAL", "TOTAL OUTPUT", "EFFICIENCY", "Productivity Rating %", "Quality Rating %", "FINAL RATING %");
    allRows.push(firstHeader);

    // Second Header Row: Month names
    const monthRow = ["", ""];
    subHeaders.forEach(month => {
      monthRow.push(month.name, ...Array(month.ranges.length).fill(""));
    });
    monthRow.push("", "", "", "", "", "", "");
    allRows.push(monthRow);

    // Third Header Row: Weekly Ranges
    const rangeRow = ["", ""];
    subHeaders.forEach(month => {
      month.ranges.forEach(range => rangeRow.push(range));
      rangeRow.push("TOTAL");
    });
    rangeRow.push("", "", "", "", "", "", "");
    allRows.push(rangeRow);

    // Team Leader Row
    allRows.push([
      `LINE ${sheetName} - ${headers.lineLeader || 'N/A'} (LINE LEADER)`,
      "",
      ...Array(reportSpan + 7).fill("")
    ]);

    // Assistant + Maker Rows
    allRows.push(...rows);

    // Totals
    allRows.push(weeklyTotalRow);
    allRows.push(monthlyTotalRow);
  });

  // Create worksheet
  const ws = XLSX.utils.aoa_to_sheet(allRows);

  // Apply styles to first 3 rows of each section
  let rowIndex = 0;
  sheetsData.forEach((_, index) => {
    if (index > 0) rowIndex++; // skip the separator row
    for (let i = 0; i < 3; i++) {
      const row = allRows[rowIndex];
      for (let col = 0; col < row.length; col++) {
        const cellRef = XLSX.utils.encode_cell({ r: rowIndex, c: col });
        const cell = ws[cellRef];
        if (cell) cell.s = headerStyle;
      }
      rowIndex++;
    }

    // Skip the rest of the section
    rowIndex += 2 + sheetsData[index].rows.length;
  });

  // Set sheet range
  const range = {
    s: { c: 0, r: 0 },
    e: { c: allRows[0]?.length - 1 || 0, r: allRows.length - 1 }
  };
  ws["!ref"] = XLSX.utils.encode_range(range);

  // Append and save
  XLSX.utils.book_append_sheet(wb, ws, 'All_TSD_Lines');
  const wbout = XLSX.write(wb, {
  bookType: "xls", // Use XLS format for limited style support
  type: "array",
  cellStyles: true // Enables style application in .xls
});

const now = new Date();
const timestamp = `${now.getMonth() + 1}_${now.getDate()}_${now.getFullYear()}-${now.getHours()}_${now.getMinutes()}`;
saveAs(new Blob([wbout], { type: "application/octet-stream" }), `TSD_Report_All_Lines${timestamp}.xls`);

}
